import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";

import Home from "./home/home.jsx";
import Press from "./press/press.jsx";
import People from "./people/people.jsx";
import Publications from "./publications/publications.jsx";
import About from './about/about.jsx';
import Teaching from './teaching/teaching.jsx';
import Blog from './blog/blog.jsx';
import BlogPostRoute from './blog/BlogPostRoute.jsx';
import PolicyBriefs from './publications/policy_briefs.jsx';
import AILaw2025 from './teaching/ai-law-2025.jsx';

const router = createHashRouter([
  {
    path: "/",
    element: <App/>,
    children: [
      {
        path: "/",
        element: <Home/>
      },
      {
        path: "press",
        element: <Press/>
      },
      {
        path: "people",
        element: <People/>
      },
      {
        path: "publications",
        element: <Publications/>
      },
      {
        path: "about",
        element: <About/>
      },
      {
        path: "teaching",
        element: <Teaching/>
      },
      {
        path: "blog",
        element: <Blog/>
      },
      {
        path: "blog/:postId",
        element: <BlogPostRoute/>
      },

      {
        path: "policy-briefs",
        element: <PolicyBriefs/>
      },
      {
        path: "ai-law-2025",
        element: <AILaw2025/>
      }
    ]
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={router} />
);

reportWebVitals();
